import type { SecurePerson } from "features/secureUploads/secureUploads";
import { formatApiError } from "utils/formatApiError";

const theFiles = (files: number) => (files > 1 ? "these files" : "this file");

/** The confirm button: who joins the project on the way, or how many files go. */
export function moveConfirmLabel(losing: SecurePerson[], files = 1): string {
  if (losing.length === 1)
    return `Add ${losing[0].name} to the project and move`;
  if (losing.length > 1)
    return `Add ${losing.length} people to the project and move`;
  return files > 1 ? `Move ${files} files` : "Move";
}

/** The warning over the people a move would leave out. */
export function losingLine(
  losing: SecurePerson[],
  projectName: string,
  files = 1,
): string {
  return losing.length === 1
    ? `${losing[0].name} isn't on ${projectName} and would lose access to ${theFiles(files)}.`
    : `These people aren't on ${projectName} and would lose access to ${theFiles(files)}.`;
}

/** The note over the people a move would show the files to. */
export function gainingLine(gaining: SecurePerson[], files = 1): string {
  const what = files > 1 ? "the files" : "the file";
  return gaining.length === 1
    ? `This person will newly see ${what} there:`
    : `These people will newly see ${what} there:`;
}

/** What a refused move says. A refusal that names who would lose the files
 * carries them as a list beside its sentence - only the sentence is shown. */
export function moveRefusal(data: unknown, fallback: string): string {
  const error = (data as { error?: unknown } | null)?.error;
  if (typeof error === "string" && error) return error;
  return formatApiError(data, fallback);
}
